
































import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "NotificationModal",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    classModal: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    buttonClose: {
      type: String,
      default: "Hủy",
    },
    buttonConfirm: {
      type: String,
      default: "Đồng ý",
    },
  },
  emits: ["close", "confirm", "update:visible"],
  setup(props, { emit }) {
    // Close the modal and emit event to parent
    const closeModal = () => {
      emit("close");
      emit("update:visible", false);
    };

    // Handle the confirm button click
    const onConfirm = () => {
      emit("confirm");
      emit("update:visible", false);
    };

    return {
      closeModal,
      onConfirm,
    };
  },
});
